import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../providers/common.services/language.service';

@Component({
  selector: 'app-view-demo',
  templateUrl: './view-demo.component.html',
  styleUrls: ['./view-demo.component.scss'],
})
export class ViewDemoComponent implements OnInit {
  lang:any;
  constructor(public translate: TranslateService,
      private langDir: LanguageService,
      public modalController: ModalController) {
      this.lang = localStorage.getItem('lang') == null ? 'en' : localStorage.getItem('lang');
      langDir.SiteLanguage$.subscribe(data => {
        console.log('vengi', data);
        if (data === 'ltr') {
          this.lang = 'en';
          this.translate.setDefaultLang('en');
          this.translate.use('en');
          // this.goBackToList();
        }
        else {
          this.lang = 'ar';
          this.translate.setDefaultLang('ar');
          this.translate.use('ar');
          // this.goBackToList();
        }
      });
      console.log('vengitest==>',this.lang)

      // this.goBackToList(); }
    }

  ngOnInit() {}

  close(){
this.modalController.dismiss()
  }


}
